class Business {
  constructor(root) {
    this.root = root;

    this.historySwiperEl = this.root.querySelector(
      ".js-business-system-swiper",
    );

    this.init();
    this.mount();
  }
  init() {
    this.historySwiperEl && this.historySwiper();
  }
  mount() {}
  historySwiper() {
    const prevEl = this.root.querySelector(".js-business-system-swiper__prev");
    const nextEl = this.root.querySelector(".js-business-system-swiper__next");
    const paginationEl = this.root.querySelector(
      ".js-business-system-swiper__pagination",
    );
    new Swiper(this.historySwiperEl, {
      loop: false,
      slidesPerView: "auto",
      navigation: {
        prevEl: prevEl,
        nextEl: nextEl,
      },
      pagination: {
        el: paginationEl,
        type: "bullets",
      },
    });
  }
}
